import React, { useState, useEffect } from 'react';
import { AiFillHome } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import WorkflowNodeTemplates from './WorkflowNodeTemplates';
import { useAuth } from '../../contexts/AuthContext';
import GenerateSnippetButton from './GenerateSnippetButton';
import EditableComponent from './EditableComponent';

const Sidebar = ({
  isnewworkflow,
  workflowid,
  workflow,
  nodes,
  workflowName,
  workflowType,
  handlePublishTemplate,
  highlight,
  setWorkflowName,
  workflowDescription,
  setWorkflowDescription,
  handleStatusChange,
  filters,
  handleCategoryChange,
  status,
}) => {
  const navigate = useNavigate();
  const [portalBuilderTemplates, setPortalBuilderTemplates] = useState([]);
  const { token } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleClick = (node_id, node_type, active, template) => {
    //console.log(workflowName, node_type, node_id);
    if (active) {
      // navigate(`/portal-builder-templates/`, {
      // state: {
      //     wfw_id: workflowid,
      //     wfw_node_id: node_id,
      // },
      // });
      //console.log(portalBuilderTemplates);

      navigate(`/portalBuilder/${template.id}`, {
        state: {
          template: template.template,
          template_id: template.id,
          template_name: template.template_name,
          template_json: template.template_json,
          template_status: template.template_status,
          wfw_id: template.wfw_id,
          wfw_node_id: template.wfw_node_id,
          delete_status: template.deleted_at,
          node_type: node_type,
        },
      });
    } else {
      navigate('/portalBuilder/create', {
        state: {
          template: '',
          template_name: workflowName,
          node_type: node_type,
          template_id: null,
          wfw_id: workflowid,
          wfw_node_id: node_id,
        },
      });
    }
  };

  useEffect(() => {
    const fetchPortalBuilderTemplates = async () => {
      try {
        const payload = {
          deleted_at: null,
          wfw_id: workflowid,
          //wfw_node_id:workflowid
        };
        // console.log(workflow);
        // if (templateStatus) {
        //   payload.template_status = templateStatus;
        // }
        if (workflow && workflow.nodes.length > 0) {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/portalbuilder/list`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `${token}`,
              },
            }
          );
          if (response) {
            const data = response.data;
            setPortalBuilderTemplates(data);
          }
        }
      } catch (error) {
        console.error('Error fetching portal builder templates:', error);
      }
    };

    fetchPortalBuilderTemplates();
    //fetchWorkflows();
  }, [workflowid, workflow]);

  const allPublished =
    workflow.nodes &&
    workflow.nodes.every((node) => {
      const template = portalBuilderTemplates.find(
        (item) => item.wfw_node_id === node.id
      );
      return template && template.template_status === 'publish';
    });

  useEffect(() => {
    // console.log(allPublished);
    handlePublishTemplate(allPublished);
  }, [allPublished]);

  /* confirm back */
  const handleBack = (e) => {
    e.stopPropagation(); // Prevent triggering the parent `onClick` event
    if (status == 'publish') {
      navigate('/');
    } else {
      setShowConfirmation(true);
    }
  };
  const confirmBack = (e) => {
    e.stopPropagation();
    setShowConfirmation(false); // Hide the confirmation block
    navigate('/');
    // setSnackbarSeverity('success');
    // setSnackbarOpen(true);
    /*if (deleteType === 'node') {
      handleDeleteNode(deleteId);
      setSnackbarMessage(`Selected widget deleted successfully`);
    } else if (deleteType === 'edge') {
      handleDeleteEdge(deleteId);
      setSnackbarMessage(`Selected edge deleted successfully`);
    } else {
      console.warn(`Unknown deleteType: ${deleteType}`);
    }  */
  };

  const cancelBack = (e) => {
    e.stopPropagation();
    setShowConfirmation(false); // Hide the confirmation block
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    const handlePopState = (event) => {
      handleBack(event); // Call your function when back button is pressed
    };
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState); // Cleanup event listener
    };
  }, []);

  return (
    <div
      style={{
        width: '300px',
        backgroundColor: '#f8f9fa',
        padding: '30px',
        boxSizing: 'border-box',
        borderRight: '1px solid #ddd',
        overflow: 'auto',
        paddingBottom: '60px',
      }}
    >
      <button
        style={{
          background: 'none',
          border: 'none',
          marginBottom: '10px',
          cursor: 'pointer',
          width: '100%',
          textAlign: 'left',
          display: 'flex',
          alignItems: 'center',
        }}
        onClick={(e) => handleBack(e)}
      >
        <AiFillHome style={{ marginRight: '8px', fontSize: '20px' }} /> /
        Workflow
      </button>

      {/* <div style={{ display: 'none', gap:'10px'  }}>
        <input
          type="text"
          value={workflowName}
          onChange={(e) => setWorkflowName(e.target.value)}
          style={{
            padding: '8px',
            fontSize: '16px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            width: '200px',
            textAlign: 'center',
          }}
        />
        // {console.log(filters)}
        <div style={{ display: 'block' }}>
            <select onChange={handleStatusChange} value={filters.status}  style={{ padding: '8px', borderRadius: '4px', display: 'block' }}>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
            </select>
            <select onChange={handleCategoryChange} value={filters.category}  style={{ padding: '8px', borderRadius: '4px', display: 'block' }}>
                <option value="">All Categories</option>
                <option value="pre-registration">Pre Registration</option>
                <option value="self-service-signup">Self service signup</option>
                <option value="gardenwall">Gardenwall</option>
                <option value="mdu">Multi dweling unit</option>
            </select>
        </div>
      </div> */}

      <EditableComponent
        workflowName={workflowName}
        setWorkflowName={setWorkflowName}
        workflowDescription={workflowDescription}
        setWorkflowDescription={setWorkflowDescription}
        handleStatusChange={handleStatusChange}
        filters={filters}
        handleCategoryChange={handleCategoryChange}
      />
      {/* {console.log(allPublished)} */}
      <span
        style={{
          border: '0.699999988079071px solid #E6E6E6',
          width: '100%',
          display: 'block',
          marginTop: '15px',
        }}
      ></span>
      {workflow.nodes && workflowType == 'type1' && (
        <span style={{ margin: '15px 0', display: 'block' }}>
          Customise Your Widget
        </span>
      )}
      {workflow.nodes &&
        workflowType == 'type1' &&
        workflow.nodes.map((node, index) => {
          const isWfwNodeIdPresent = portalBuilderTemplates.some(
            (item) => item.wfw_node_id === node.id
          );
          const template = portalBuilderTemplates.find(
            (item) => item.wfw_node_id === node.id
          );
          //console.log(template.template_status);
          return (
            <WorkflowNodeTemplates
              key={node.id}
              title={node.data.label}
              type={node.type}
              handleClick={() =>
                handleClick(node.id, node.type, isWfwNodeIdPresent, template)
              }
              active={isWfwNodeIdPresent}
              status={template ? template.template_status : ''}
              highlight={highlight}
              //   updated_at={node.updated_at}
              //   description={`node ${index + 1}: ${node.node_name}`}
              //   onClick={() => handlenodeClick(node)}
              //   onDelete={() => handleDeletenode(node.id)}
            />
          );
        })}
      {!isnewworkflow && workflowType == 'type1' && (
        <GenerateSnippetButton
          workflowId={workflowid}
          allPublished={allPublished}
        />
      )}

      {showConfirmation && (
        <div
          className="delete-block"
          style={{
            position: 'absolute',
            top: '50%',
            left: '0',
            right: '0',
            transform: 'translate(0, -50%)',
            backgroundColor: 'white',
            padding: '15px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)',
            borderRadius: '8px',
            zIndex: 1000,
            width: '300px',
            margin: 'auto',
          }}
        >
          <p>Are you sure you want to leave without publish workflow?</p>
          <button
            onClick={confirmBack}
            style={{
              backgroundColor: '#dc3545',
              color: '#fff',
              border: 'none',
              padding: '3px 12px',
              borderRadius: '3px',
              cursor: 'pointer',
              marginRight: '10px',
              fontWeight: 'bold',
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#c82333')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#dc3545')}
          >
            Yes
          </button>
          <button
            onClick={cancelBack}
            style={{
              backgroundColor: '#6c757d',
              color: '#fff',
              border: 'none',
              padding: '3px 12px',
              borderRadius: '3px',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#5a6268')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#6c757d')}
          >
            No
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
